module.exports = __webpack_public_path__ + "static/img/86061A_3_C_20220712_LC.401d4a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/86061A_3_C_20220712_LC.png
// module id = 6TXV
// module chunks = 0